import fetch from '../utils/fetch';

export const changePhrase = value => ({
	type: 'CHANGE_PHRASE',
	payload: value,
});

export const queryPatients = (clinic, searchPhrase) => (dispatch) => {
	dispatch({
		type: 'QUERY_PATIENTS',
	});

	const url = `/api/patient?search=${encodeURIComponent(searchPhrase)}${clinic !== null ? `&clinic=${encodeURIComponent(clinic)}` : ''}`;
	return fetch(url).then(({ patients }) => {
		dispatch({
			type: 'RECEIVE_PATIENTS',
			payload: patients,
		});
	});
};

export const clearPatients = () => ({
	type: 'CLEAR_PATIENTS',
});

export const selectPatient = patient => ({
	type: 'SELECT_PATIENT',
	payload: patient,
});



// WEBPACK FOOTER //
// ./js/actions/searchActions.js